import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import "./SignupCommon.css";
import "./Signup6.css";
import image from "../../assets/images/than_and_now.png";
import arrow from "../../assets/images/arrow.png";
const SignupPage17: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const step11Completed = localStorage.getItem("step-11-completed");
    const isVariant = localStorage.getItem("isVariant") === "true"
    if(isVariant){
      return;
    }
    if (step11Completed) {
      navigate("/getting-started/step-12", { replace: true });
    } else {
      navigate("/getting-started/step-11", { replace: true });
    }
  }, []);

  const handleNext = () => {
    localStorage.setItem("step-12-completed", "true");
    navigate("/getting-started/step-13");
  };
  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <div className="signup-content">
          <h1 className="client-content common-content-type">
            “I lost 40 pounds, lowered my blood pressure, and finally have the
            energy to keep up with my kids. At 43, I feel healthier and stronger
            than ever!”
          </h1>
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              marginTop: "30px",
            }}
          >
            <img
              src={image}
              alt="Before and After"
              className="beforeAndAfterImage"
              style={{
                width: "100%",
                height: "auto",
              }}
            />

            <div
              style={{
                position: "absolute",
                top: "0",
                left: "55%",
                transform: "translateX(-60%)", 
                width: "8px", 
                height: "100%", 
                backgroundColor: "white", 
              }}
            ></div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "22px",
            }}
          >
          </div>
          <div>
            <span className="client-info">
              Karli dropped her blood pressure and upped her confidence in only
              5 months
            </span>
          </div>
            <button
              onClick={handleNext}
              className="next-btn sticky-btn"
              style={{ marginTop: "20px" }}
            >
              Continue{" "}
              <img src={arrow} alt="Arrow" style={{ marginLeft: "8px" }} />
            </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage17;
